import React from 'react'

const LayoutSG = () => {
    return (
        <div className="demo-layout">
            {/* Fullwidth Column 12/12  */}
            <div className="row">
                <div className="columns small-12">
                    <div className="grid-content bg-purple-dark"></div>
                </div>
            </div>

            {/* 50% Column 6/12  */}
            <div className="row">
                <div className="columns medium-6">
                    <div className="grid-content bg-purple"></div>
                </div>
                <div className="columns medium-6">
                    <div className="grid-content bg-purple-light"></div>
                </div>
            </div>

            {/* 33% Column 4/12  */}
            <div className="row">
                <div className="columns medium-4">
                    <div className="grid-content bg-purple-light"></div>
                </div>
                <div className="columns medium-4">
                    <div className="grid-content bg-purple"></div>
                </div>
                <div className="columns medium-4">
                    <div className="grid-content bg-purple-light"></div>
                </div>
            </div>

            {/* 25% Column 3/12  */}
            <div className="row">
                <div className="columns medium-3">
                    <div className="grid-content bg-purple-light"></div>
                </div>
                <div className="columns medium-3">
                    <div className="grid-content bg-purple"></div>
                </div>
                <div className="columns medium-3">
                    <div className="grid-content bg-purple-light"></div>
                </div>
                <div className="columns medium-3">
                    <div className="grid-content bg-purple"></div>
                </div>
            </div>
        </div>
    )
}

export default LayoutSG
